<template>
  <div class="get_coupon_wrap">
    <div class="bg_top">
      <img :src="require('assets/img/bg/m_coupon_bg2.png')" />
    </div>
    <div class="bg_bottom">
      <img :src="require('assets/img/bg/coupon_bg3.png')" />
    </div>
    <div class="bg_center">
      <div class="title">
        <img :src="require('assets/img/bg/coupon_title.png')" />
      </div>
      <Coupons :coupons="issued_coupons.coupons"
         :user_limit_visible="true"
         :btn_issue="false"
         :btn_detail="false"
         @issue-coupons="issueCoupons"></Coupons>
      <div class="buttons">
        <van-button round block type="danger" @click="issueCoupons">立即领取</van-button>
        <van-button round block type="default" @click="showMyCoupons" v-if="issued_coupons.coupons.user_issued > 0">查看我的优惠券</van-button>
      </div>
    </div>
  </div>
</template>

<script>
  import Coupons from "components/mobile/settlement/Coupons"
  import {fmtCouponsInfo} from 'api/settlement/coupons/admin'
  import {issueLink, listCouonsUser, getCouponsByStrategyCode} from 'api/settlement/coupons/user'
  import { GetUserState, LoginUser, LogOutUser } from 'api/user/auth/login'
  import { db_time_to_local_fmt } from 'utils/timeutils'

  export default {
    components: {
      Coupons,
    },
    created() {

      if (this.$route.params.strategy_code != undefined && this.$route.params.strategy_code != '') {
        this.strategy_code = this.$route.params.strategy_code;

        this.loadData();

      } else {

          this.result_mode = 'error';
          this.result_msg = '非法访问,参数丢失';

      }
    },
    data() {

     return {
       issue_loading: false,
       result_mode: null,
       result_msg: null,
       show_my_coupons: false,
       issued_coupons: {
           coupons:{
               user_issued: 0
           }
       },
       issued_remain_count_text: '',
       is_user_limit: true,
       user_remain_count: 0,
       strategy_code: null,
     }
    },
    mounted() {
      this.$emit('update:isShowHeader', true);
    },
    methods: {

      async loadData(){

          const that = this;

          this.$emit('update:isShowOverlay', true);

          await getCouponsByStrategyCode(this.strategy_code).then(result=>{

              if (result.count > 0){

                  that.issued_coupons.coupons = fmtCouponsInfo(result.data);

              } else {
                  this.goPath('/404')
              }

              this.$emit('update:isShowOverlay', false);

          }).catch(err=>{

            this.result_mode = 'error';
            this.result_msg = err;

            this.$emit('update:isShowOverlay', false);

          });
      },

      async issueCoupons(){

        const that = this;

        this.issue_loading = true;

        await issueLink(this.strategy_code).then(result => {

            that.issue_loading = false;

            if (result.succeed){

                this.result_mode = 'succeed';

                if(result.instance.coupons){
                    result.instance.coupons = fmtCouponsInfo(result.instance.coupons);
                    that.issued_coupons.coupons  = result.instance.coupons;
                }

                result.instance.expired_at = db_time_to_local_fmt(result.instance.time_end);

                this.issued_coupons = result.instance;
                this.user_remain_count = result.user_remain_count;
                this.is_user_limit = result.is_user_limit;
                this.show_my_coupons = true;

                this.$notify({
                  title: '领取成功',
                  message: '优惠券已放入卡包~',
                  type: 'success'
                });

                if (result.is_user_limit && result.user_remain_count) {
                    this.issued_remain_count_text = `（还可领取${result.user_remain_count}次）`;
                } else {
                    this.issued_remain_count_text = '';
                }

            } else {

                switch(result.error_code){
                  case -9999: { // not login

                    this.result_mode = 'not_login';
                    this.showLoginModal();

                  } break;
                  default: {

                    this.result_mode = 'error';
                    this.result_msg = result.error_msg;
//                    this.show_my_coupons = true;

                    this.$notify({
                      title: '提示',
                      message: result.error_msg,
                      type: 'warning'
                    });

                  } break;
                }
            }


        }).catch(err => {

          that.issue_loading = false;

          this.result_mode = 'error';
          this.result_msg = err;

        });
        console.log(this.issued_coupons.coupons);

      },
      goPath(path) {
        this.$router.push(path);
      },
      showMyCoupons(){
          this.goPath('/mobile/center/card/coupons')
      },
      showLoginModal(){

       this.$emit('update:loginVisible', true);

      }
    }
  }
</script>

<style lang="scss" scoped>
  .get_coupon_wrap {
    min-height: calc(100vh - 60px - 57px);
    background-image: linear-gradient(to right, #a164ff , #6263ff);
    position:relative;
    padding:15px;
    .bg_top {
      z-index:1;
      position:absolute;
      top:5px;
      left:10%;
      > img {
        display:block;
        height:50px;
      }
    }
    .bg_bottom {
      z-index:1;
      position:absolute;
      bottom:0;
      right:0;
      > img {
        display:block;
        width:70px;
      }
    }
    .bg_center {
      background:#fff url('~@/assets/img/bg/m_coupon_bg1.png') repeat;
      border-radius:10px;
      padding:50px 15px 15px 15px;
      margin:0 auto;
      position:absolute;
      top:15px;
      left:15px;
      right:15px;
      bottom:15px;
      .title {
        > img {
          display:block;
          width:80%;
          margin:0 auto 35px;
        }
      }
      .buttons {
        padding-top:40px;
        > button {
          height:40px;
          width:80%;
          margin:0 auto 20px;
        }
      }
    }
  }
</style>
